import { ReactNode } from 'react'

import { Form } from 'factorial-form'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { formGetDirtyFields } from 'modules/core/lib/formGetDirtyFields'

import ContractFlowStep from 'modules/contracts/lib/ContractFlowStep'

class FixFlowStep extends ContractFlowStep {
  constructor(title: string, component: ReactNode, description?: string) {
    super(title, component, description)
  }

  trackNext(form: Form, step: number): void {
    track(trackingEvents.employee.contracts.fixContractNext, {
      step: step,
      fields_edited: formGetDirtyFields(form),
      fields_completed: form.fieldsWithValueKeys,
    })
  }

  trackBack(form: Form, step: number): void {
    track(trackingEvents.employee.contracts.fixContractBack, {
      step: step,
      fields_edited: formGetDirtyFields(form),
      fields_completed: form.fieldsWithValueKeys,
    })
  }

  trackSubmit(form: Form): void {
    track(trackingEvents.employee.contracts.fixContractSubmit, {
      fields_edited: formGetDirtyFields(form),
      fields_completed: form.fieldsWithValueKeys,
    })
  }

  trackExit(step: number): void {
    track(trackingEvents.employee.contracts.fixContractExit, {
      step: step,
    })
  }
}

export default FixFlowStep
